import { render, staticRenderFns } from "./AdminTipiBollettaView.vue?vue&type=template&id=5116c254&"
import script from "./AdminTipiBollettaView.vue?vue&type=script&lang=ts&"
export * from "./AdminTipiBollettaView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports